export default /* glsl */ `vec4 fragmentRGBA(vec4 rgba, vec4 stpq) {
  return rgba;
}`;
